import React, { ReactElement } from 'react';
import { Link } from 'idsk-react-components';
import { useParams } from 'react-router';
import routes from '../../../../routing/routes';
import forum from '../../icons/forum.svg';
import UserRole from '../../../../model/currentuser/UserRole';
import Secured from '../../../Secured';

interface Props {
  setOpenDropdown: (opened: boolean) => void;
}

const AddHromadnaPripomienkaAdminButton = ({ setOpenDropdown }: Props): ReactElement => {
  // @ts-ignore
  const { type, year, index } = useParams<{ type: string, year: number, index: number }>();

  return (
    <Secured
      allowForRoles={[UserRole.SUPERADMIN]}
    >
      <li key="Pridať hr. prip. (admin)" className="action-item">
        <div className="icon-wrapper">
          <img src={forum} className="icon" alt="Pridať hr. prip. (admin)" />
        </div>
        <Link
          onClick={() => setOpenDropdown(false)}
          to={routes.admin.hromadnePripomienky.add.withParams(type, year, index)}
          className="button-inline-text"
        >Pridať hromadnú pripomienku (admin)
        </Link>
      </li>
    </Secured>
  );
};

export default AddHromadnaPripomienkaAdminButton;
